import WithRoutePermission from "shared/components/HOC/WithRoutePermission";
import { MODULES, SCREENS, SUBMODULES } from "utils/constants";
import Create from "./Create";
import Delete from "./Delete";
import Detail from "./Detail";
import List from "./List";
import SellerCodes from "./SellerCodes";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.LIST.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PRODUCT_RANGE]: SUBMODULES.ADMIN_LIST }}
        WrappedComponent={List}
      />
    ),
  },
  {
    path: SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.SELLER_CODES.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PRODUCT_RANGE]: SUBMODULES.ADMIN_LIST }}
        WrappedComponent={SellerCodes}
      />
    ),
  },
  {
    path: SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.CREATE.path,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PRODUCT_RANGE]: SUBMODULES.ADMIN_CREATE }}
        WrappedComponent={Create}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.DETAIL.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PRODUCT_RANGE]: SUBMODULES.ADMIN_DETAIL }}
        WrappedComponent={Detail}
      />
    ),
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.DELETE.path}/:id`,
    exact: true,
    element: (
      <WithRoutePermission
        submodules={{ [MODULES.PRODUCT_RANGE]: SUBMODULES.ADMIN_DELETE }}
        WrappedComponent={Delete}
      />
    ),
  },
];

export default routes;
